import { render, staticRenderFns } from "./DashboardSatuSehat.vue?vue&type=template&id=50cf406f&scoped=true"
import script from "./DashboardSatuSehat.vue?vue&type=script&lang=js"
export * from "./DashboardSatuSehat.vue?vue&type=script&lang=js"
import style0 from "./DashboardSatuSehat.vue?vue&type=style&index=0&id=50cf406f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cf406f",
  null
  
)

export default component.exports